import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Flex, FlexItem, Select, Text } from 'mailup-web-components'

import { modalBulkRemoveFromGroupsChangeCallback } from 'Pages/RecipientsList/recoil/callbacks/modalBulkRemoveFromGroups'
import { modalBulkRemoveFromGroupsState } from 'Pages/RecipientsList/recoil/state/modals'

const InputRemoveFromGroups: FC = () => {
  const intl = useIntl()

  const { removeFromGroupsMode, searchGroups } = useRecoilValue(
    modalBulkRemoveFromGroupsState,
  )

  const modalStateChange = useRecoilCallback(
    modalBulkRemoveFromGroupsChangeCallback,
    [],
  )

  const options = [
    {
      label: intl.formatMessage({
        id: 'Load.RecipientsList.OptRemoveFromSearchGroups',
      }),
      value: 'search',
    },
    {
      label: intl.formatMessage({
        id: 'Load.RecipientsList.OptRemoveFromBelongingGroups',
      }),
      value: 'all',
    },
  ]

  const handleChange = (v: 'all' | 'search'): void => {
    void modalStateChange({ removeFromGroupsMode: v })
  }

  return searchGroups.length > 0 ? (
    <Flex alignItems="center" gap="8px">
      <FlexItem alignItems="center" flexGrow={0}>
        <Text>
          {intl.formatMessage({
            id: 'Load.RecipientsList.RemoveFromGroupsModeSelect',
          })}
        </Text>
      </FlexItem>

      <FlexItem alignItems="center" flexGrow={1}>
        <Select
          value={removeFromGroupsMode}
          options={options}
          data-mu-test="remove-from-groups-mode"
          searchable={false}
          onChange={handleChange}
        />
      </FlexItem>
    </Flex>
  ) : (
    <Text>
      {intl.formatMessage({
        id: 'Load.RecipientsList.RemoveFromGroupsAskConfirm',
      })}
    </Text>
  )
}

export default InputRemoveFromGroups
